/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, useHistory, useLocation } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import useCustomToast from "../../hooks/useCustomToasts";

const LayoutRoute = ({
  component: Component,
  layout: Layout,
  validations,
  loginRequired = false,
  ...rest
}) => {
  const [loading, setLoading] = useState(false);
  const toasts = useCustomToast();

  const { addToast } = useToasts();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const qParams = queryString.parse(location.search);
  const dataUsuario = useSelector((state) => state.datosUsuarios.dataUsuario);

  useEffect(() => {
    if (qParams["in-progress"]) {
      toasts.addWarningToast("Sección en construcción");
    }
  }, []);

  useEffect(() => {
    console.log("RUTA: ", rest);
    if (loginRequired && !dataUsuario?.userIsLoggedIn) {
      console.log("SSO: ", loginRequired, rest);
      history.push("/login?user=agentes");
    }
  }, [Component]);

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout {...rest}>
          <Component
            {...{
              ...toasts,
              loading,
              setLoading,
              addToast,
              qParams,
              history,
              dispatch,
              params: props.match.params,
              dataUsuario,
              validations,
            }}
          />
        </Layout>
      )}
    />
  );
};

export default LayoutRoute;
